import { render, staticRenderFns } from "./RelationModal.vue?vue&type=template&id=70e86c7e"
import script from "./RelationModal.vue?vue&type=script&lang=js"
export * from "./RelationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports